import { SafariObjectId } from '@safarilaw-webapp/shared/common-objects-models';

export class ReduxBoolean {
  value: boolean;
}
export class ReduxString {
  value: string;
}
export class ReduxAny {
  value: any;
}
export class ReduxObjectSaveInfo {
  id: SafariObjectId;
  saving: boolean;
}
export class ReduxFormErrorInfo {
  keyControl: string;
  keyError: string;
  error: any;
}
